export var BusinessUnitEntityAttributes;
(function (BusinessUnitEntityAttributes) {
    BusinessUnitEntityAttributes.EntityName = "businessunit";
    BusinessUnitEntityAttributes.LogicalName = "_businessunitid_value@OData.Community.Display.V1.FormattedValue";
})(BusinessUnitEntityAttributes || (BusinessUnitEntityAttributes = {}));
